<div class="listing-page">
  <div class="listing-container">
    <div class="listing-layout">
      <!-- Desktop Sidebar -->
      <aside class="listing-sidebar">
        <app-filter-panel
          [config]="filterConfig"
          [activeFilters]="activeFilters()"
          currentSource="merchandises"
          (filterChange)="onFilterChange($event)"
          (sourceChange)="onSourceChange($event)"
          (applyAll)="closeFilterDrawer()"
          (clearAll)="clearAllFilters()"
        >
        </app-filter-panel>
      </aside>

      <!-- Main Content Area -->
      <main class="listing-content">
        <!-- Toolbar -->
        <div class="listing-toolbar">
          <app-list-toolbar
            [total]="totalItems()"
            [page]="currentPage()"
            [pageSize]="pageSize"
            [viewMode]="viewMode()"
            [currentSort]="currentSort()"
            (viewChange)="onViewChange($event)"
            (sortChange)="onSortChange($event)"
            (filterToggle)="onFilterToggle()"
          >
          </app-list-toolbar>
        </div>

        <!-- Product Grid -->
        <!-- Product Grid -->
        <div class="listing-grid" [class.list-view]="viewMode() === 'list'">
          <!-- Skeletal Loaders -->
          <ng-container *ngIf="isLoading()">
            <div class="skeleton-card" *ngFor="let i of [1, 2, 3, 4, 5, 6]">
              <div class="skeleton-image shimmer"></div>
              <div class="skeleton-content">
                <div class="skeleton-title shimmer"></div>
                <div class="skeleton-text shimmer"></div>
                <div class="skeleton-text shimmer half"></div>
                <div class="skeleton-footer shimmer"></div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!isLoading()">
            <!-- Empty State -->
            <div class="empty-state" *ngIf="products().length === 0">
              <div class="empty-state-icon">
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <h3 class="empty-state-title">No merchandise found</h3>
              <p class="empty-state-subtitle">Try adjusting your filters or search criteria</p>
              <button class="empty-state-button" (click)="clearAllFilters()">
                Clear All Filters
              </button>
            </div>

            <!-- Product Cards -->
            <app-product-card
              *ngFor="let product of products()"
              [product]="product"
              [isListView]="viewMode() === 'list'"
              [variant]="'compact'"
            >
            </app-product-card>
          </ng-container>
        </div>

        <!-- Pagination -->
        <div class="listing-pagination" *ngIf="totalItems() > 0">
          <app-pagination
            [page]="currentPage()"
            [total]="totalItems()"
            [pageSize]="pageSize"
            (pageChange)="onPageChange($event)"
          >
          </app-pagination>
        </div>
      </main>
    </div>
  </div>

  <!-- Mobile Filter Drawer -->
  <div
    class="filter-drawer-overlay"
    *ngIf="isFilterDrawerOpen()"
    (click)="onDrawerBackdropClick()"
  ></div>

  <aside class="filter-drawer" [class.open]="isFilterDrawerOpen()">
    <div class="filter-drawer-header">
      <button class="filter-drawer-close" (click)="closeFilterDrawer()" aria-label="Close Filters">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
    <div class="filter-drawer-content">
      <app-filter-panel
        [config]="filterConfig"
        [activeFilters]="activeFilters()"
        currentSource="merchandises"
        (filterChange)="onFilterChange($event)"
        (sourceChange)="onSourceChange($event)"
        (applyAll)="closeFilterDrawer()"
        (clearAll)="clearAllFilters()"
      >
      </app-filter-panel>
    </div>
    <div class="filter-drawer-footer">
      <button class="filter-drawer-clear" (click)="clearAllFilters()">Clear All</button>
      <button class="filter-drawer-apply" (click)="closeFilterDrawer()">Apply Filters</button>
    </div>
  </aside>
</div>
